export default __webpack_public_path__ + "static/media/bcfNZPrsaLogoWhite.23a677c6.svg";